import { Button } from '@frontend/generic-dialpad-accessories';
import { useSoftphoneCallActions } from '../../providers/softphone-call-state-provider/softphone-call-actions.provider';
import { IncomingCall } from '../../types';

type Props = {
  incomingCall: IncomingCall;
};

export const IncomingCallBarContent = ({ incomingCall }: Props) => {
  const endCall = useSoftphoneCallActions((ctx) => ctx.endCall);
  const answerIncomingCall = useSoftphoneCallActions((ctx) => ctx.answerIncomingCall);

  return (
    <>
      <Button.Round
        onClick={() => {
          endCall(incomingCall);
        }}
        color='red'
        size='small'
        iconName='phone-hangup'
      ></Button.Round>
      <Button.Round onClick={() => answerIncomingCall(incomingCall)} iconName='phone' color='green' size='small' />
    </>
  );
};
